import './style.scss';

import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import scrollIntoView from 'scroll-into-view';
import RadioButton from '../ui/radioButton';
import UserAddressForm from './form';
import {
  editAddress,
  updateAddress
} from './actions';
import { trackNow } from 'shared/models/analytic';

function AddressItem(props) {
  const address = props.address;
  const id = `saved-address-${address.clientId}`;
  const title = [address.address, address.unit, address.zip]
    .filter(str => !_.isEmpty(str))
    .join(', ')
  const checked = props.checked;
  const itemClassName = "radio-list__option" +
    (checked ? " radio-list__option--checked" : "");
  const btnClassName = "radio-list__radio-btn" +
    (checked ? " radio-list__radio-btn--checked" : "");

  return (
    <RadioButton
      name="saved-address"
      id={id}
      onChange={props.onChange}
      checked={checked}
      containerClass={itemClassName}
      btnClass={btnClassName}
    >
      <div className="radio-list__content">
        <div className="row middle-xs">
          <div className="col-xs">
            <div className="radio-list__strong">{title}</div>
            { !address.shipping && (address.notes ?
              <div className="quote-text text-overflow">{address.notes}</div> :
              <a className="link-text" onClick={props.edit}>Add Delivery Notes</a>
            )}
          </div>

          { address.saved && (
            <div className="col-xs-3 col-sm-2">
              <div className="radio-list__label radio-list__highlight">
                {address.label}
              </div>
              <div className="radio-list__label-btn">
                <button type="button" className="btn-small btn--inline link-text--secondary" onClick={props.edit}>
                  Edit
                </button>
              </div>
            </div>
          )}

        </div>
      </div>
    </RadioButton>
  )
}

class AddressPicker extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showNewAddress: this.selectedAddressIsNew(props),
      newAddress: this.selectedAddressIsNew(props) ? props.selectedAddress : {}
    }
  }

  componentDidMount() {
    const containerRect = this.container.getBoundingClientRect();
    if (containerRect && containerRect.top < 0) scrollIntoView(this.container);
  }

  selectedAddressIsNew(props) {
    const addressIds = props.addresses.map(a => a.clientId);
    const selectedAddress = props.selectedAddress;
    const selectedAddressId = selectedAddress && selectedAddress.clientId;
    return !selectedAddressId || !_.includes(addressIds, selectedAddressId);
  }

  openNewAddress() {
    this.setState({ showNewAddress: true })
    trackNow('Add New Address Clicked')
  }

  closeNewAddress() {
    this.setState({ showNewAddress: false })
    trackNow('Add New Address Canceled')
  }

  select(address) {
    this.closeNewAddress();
    return this.props.onSelectionChange(address)
  }

  confirmSelection() {
    return this.props.onBeforeSubmit()
      .then(() => this.props.onSelectionSubmit())
      .catch(() => {})
  }

  submitNewAddress(address) {
    this.setState({ newAddress: address });
    return this.props.onNewAddressSubmit(address);
  }

  render() {
    const addresses = this.props.addresses;
    const selected = !this.state.showNewAddress && this.props.selectedAddress;
    const selectedId = selected && selected.clientId;
    const homeAddress = _.find(addresses, { label: 'Home' });
    const workAddress = _.find(addresses, { label: 'Work' });
    const rest = _.reject(addresses, address => (address.label === 'Home' || address.label === 'Work'));
    const saved = _.filter(rest, 'saved');
    const recent = _.filter(rest, 'recent');
    const rowFor = (address) => (
      <AddressItem
        key={address.clientId}
        address={address}
        onChange={() => this.select(address)}
        checked={selectedId === address.clientId}
        edit={() => this.props.editAddress({...address})}
      />
    )

    return (
      <div ref={(div) => this.container = div}>
        <div className="radio-list vertical-rhythm">
          { homeAddress && rowFor(homeAddress) }
          { workAddress && rowFor(workAddress) }
          { saved.map(rowFor) }
          { recent.map(rowFor) }
        </div>

        { this.state.showNewAddress ?
            <UserAddressForm
              address={this.state.newAddress}
              onBeforeSubmit={() => this.props.onBeforeSubmit()}
              onSubmit={(address) => this.submitNewAddress(address)}
              onSuccess={() => this.props.onNewAddressSuccess()}
              onCancel={() => this.closeNewAddress()}
              fieldsContainer={NewFieldsContainer}
            /> :

            <div>
              <button
                type="button"
                className="btn--full-width btn--tertiary user-addresses__btn"
                onClick={() => this.openNewAddress()}
              >
                <span className="svg-icon svg-icon--plus" />
                Add New Delivery Address
              </button>

              <div className="row">
                <div className="col-xs-12 col-md-5 col-md-offset-7 col-lg-4 col-lg-offset-8">
                  <button
                    type="button"
                    className="btn-primary green btn--full-width"
                    onClick={() => this.confirmSelection()}
                  >
                    Continue
                  </button>
                </div>
              </div>
            </div>
        }
      </div>
    )
  }
}

function EditFieldsContainer(props) {
  return (
    <div className="checkout-subsection">
      <h3 className="user-addresses__form-heading">Edit Delivery Address</h3>
      { props.children }
    </div>
  )
}

function NewFieldsContainer(props) {
  return (
    <div className="checkout-subsection">
      <h3 className="user-addresses__form-heading">New Delivery Address</h3>
      { props.children }
    </div>
  )
}

class UserAddresses extends React.Component {
  render() {
    if (!this.props.addresses.length) return (
      <UserAddressForm
        address={this.props.selectedAddress}
        onBeforeSubmit={() => this.props.onBeforeSubmit()}
        onSubmit={(address) => this.props.onNewAddressSubmit(address)}
        onSuccess={() => this.props.onNewAddressSuccess()}
      />
    )

    if (this.props.editingAddress) return (
      <UserAddressForm
        address={this.props.editingAddress}
        onBeforeSubmit={() => this.props.onBeforeSubmit()}
        onSubmit={(address) => this.props.updateAddress(address)}
        onSuccess={(address) => this.props.editAddress(null) && this.props.onUpdateAddressSuccess(address)}
        onCancel={() => this.props.editAddress(null)}
        fieldsContainer={EditFieldsContainer}
      />
    )

    return <AddressPicker {...this.props} />
  }
}

UserAddresses = connect(state => ({
  addresses: state.userAddresses.addresses,
  editingAddress: state.userAddresses.editingAddress
}), {
  editAddress,
  updateAddress
})(UserAddresses);

export default UserAddresses;



// WEBPACK FOOTER //
// ./shared/components/userAddresses/index.js